<template>
  <div>
    <page-header></page-header>
    <!-- New Course -->
    <section class="page-content course-sec">
      <div class="container">
        <div class="row align-items-center" style="margin-top: 50px;">
          <div class="col-md-12">
            <div class="add-course-header">
              <h2>{{ courseEntity.id ? 'Editar Curso' : 'Adicionar Novo Curso' }}</h2>
              <div class="add-course-btns">
                <ul class="nav">
                  <li>
                    <router-link to="/caduceus/course" class="btn btn-black">Voltar para Cursos</router-link>
                  </li>
                  <li v-if="canViewCourse">
                    <router-link :to="`/caduceus/courses/${courseEntity.id}/preview`" class="btn btn-primary">Visualizar</router-link>
                  </li>
                  <li>
                    <a @click="salvar()" class="btn btn-success-dark">Salvar</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <!-- Course Wizard -->
              <div class="widget-set">
                <div class="widget-setcount">
                  <ul id="progressbar" v-show="currentStep === 1">
                    <li class="progress-active">
                      <p><span></span> Informações Básicas</p>
                    </li>
                    <li>
                      <p><span></span> Mídias</p>
                    </li>
                    <li>
                      <p><span></span> Conteúdo</p>
                    </li>
                    <li>
                      <p><span></span> Configurações</p>
                    </li>
                  </ul>
                  <ul id="progressbar" v-show="currentStep === 2">
                    <li>
                      <p><span></span> Informações Básicas</p>
                    </li>
                    <li class="progress-active">
                      <p><span></span> Mídias</p>
                    </li>
                    <li>
                      <p><span></span> Conteúdo</p>
                    </li>
                    <li>
                      <p><span></span> Configurações</p>
                    </li>
                  </ul>
                  <ul id="progressbar" v-show="currentStep === 3">
                    <li>
                      <p><span></span> Informações Básicas</p>
                    </li>
                    <li>
                      <p><span></span> Mídias</p>
                    </li>
                    <li class="progress-active">
                      <p><span></span> Conteúdo</p>
                    </li>
                    <li>
                      <p><span></span> Configurações</p>
                    </li>
                  </ul>
                  <ul id="progressbar" v-show="currentStep === 4">
                    <li>
                      <p><span></span> Informações Básicas</p>
                    </li>
                    <li>
                      <p><span></span> Mídias</p>
                    </li>
                    <li>
                      <p><span></span> Conteúdo</p>
                    </li>
                    <li class="progress-active">
                      <p><span></span> Configurações</p>
                    </li>
                  </ul>
                </div>
                <div class="widget-content ">
                  <fieldset id="first" v-if="currentStep === 1">
                    <div class="add-course-info">
                      <div class="add-course-inner-header">
                        <h4>Informações Básicas</h4>
                      </div>
                      <div class="add-course-form">
                        <form action="#">
                          <div class="form-group">
                            <label class="add-course-label">Título</label>
                            <input type="text" class="form-control" placeholder="Título" v-model="courseEntity.title" />
                          </div>
                          <div class="form-group">
                            <label class="add-course-label">Inscrutor</label>
                            <vue-select :options="Inscructors" placeholder="Selecione"
                              v-model="courseEntity.instructorId" />
                          </div>
                          <div class="form-group">
                            <label class="add-course-label">Courses Category</label>
                            <vue-select :options="Category" placeholder="Selecione" v-model="courseEntity.categoryId" />
                          </div>
                          <div class="form-group">
                            <label class="add-course-label">Courses Level</label>
                            <vue-select :options="Level" placeholder="Selecione" v-model="courseEntity.level" />
                          </div>
                          <div class="form-group mb-0">
                            <label class="add-course-label">Descrição do Curso</label>
                            <div id="editor">
                              <ckeditor class="" :editor="editor" v-model="courseEntity.description"
                                :config="editorConfig"></ckeditor>
                            </div>
                          </div>
                        </form>
                      </div>
                      <!-- {{ courseEntity }} -->
                      <div class="widget-btn">
                        <!-- <a class="btn btn-black"></a> -->
                        <div></div>
                        <a class="btn btn-info-light next_btn" @click="nextStep"
                          :disabled="currentStep === totalSteps">Próximo</a>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="field-card" v-if="currentStep === 2">
                    <div class="add-course-info">
                      <div class="add-course-inner-header">
                        <h4>Mídias</h4>
                      </div>
                      <div class="add-course-form">
                        <form action="#">
                          <div class="input-block">
                            <label class="add-course-label">Imagem de Capa</label>
                            <div class="relative-form">
                              <span>No File Selected</span>
                              <label class="relative-file-upload">
                                Upload <input id="fileInput" type="file" class="form-control"
                                  @change="handleFileChange" />
                              </label>
                            </div>
                          </div>
                          <div class="input-block">
                            <div class="add-image-box">
                              <a href="javascript:void(0);" v-if="!courseEntity.coverImage">
                                <i class="far fa-image" v-if="!courseEntity.coverImage"></i>

                              </a>
                              <img :src="courseEntity.coverImage" v-if="courseEntity.coverImage" height="207">
                            </div>
                          </div>
                          <div class="input-block">
                            <input type="text" class="form-control" placeholder="Video URL"
                              v-model="courseEntity.videoUrl" />
                          </div>
                          <div class="input-block">
                            <LiteYouTubeEmbed v-if="courseEntity.videoUrl" :id="courseEntity.videoUrl?.split('=')[1]"
                              width="320" title="Rick Astley - Never Gonna Give You Up (Official Music Video)" />
                            <div class="add-image-box add-video-box" v-if="!courseEntity.videoUrl">

                              <a href="javascript:void(0);">
                                <i class="fas fa-circle-play"></i>
                              </a>

                              <!-- <youtube video-id="dQw4w9WgXcQ"></youtube> -->


                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="widget-btn">
                        <a class="btn btn-black prev_btn" @click="previousStep"
                          :disabled="currentStep === 1">Anterior</a>
                        <a class="btn btn-info-light next_btn" @click="nextStep"
                          :disabled="currentStep === totalSteps">Próximo</a>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="field-card" v-if="currentStep === 3">
                    <div class="add-course-info">
                      <div class="add-course-inner-header">
                        <h4>Conteúdo</h4>
                      </div>
                      <div class="add-course-section">
                        <a @click="addModulo()" class="btn">Add Módulo</a>
                      </div>
                      <div class="add-course-form">
                        <div v-for="(modulo, sectionIndex) in courseEntity.modules" :key="modulo.order"
                          class="curriculum-grid">
                          <div class="curriculum-head">
                            <p>Módulo {{ sectionIndex + 1 }}: {{ modulo.title }}</p>
                            <div>
                              <a @click="addLesson(modulo)" class="btn" style="margin-right: 10px">Add Aula</a>
                              <a @click="removeModulo(modulo)" class="remove-btn" style="cursor: pointer;"><i
                                  class="far fa-trash-alt"></i></a>
                            </div>
                          </div>
                          <input type="text" class="form-control mb-12" style="padding-bottom: 12px;"
                            placeholder="Título" v-model="modulo.title" />
                          <div class="curriculum-info" style="margin-top: 16px;">
                            <div id="accordion">
                              <div class="faq-grid empty-section-dropzone" v-if="modulo.lessons.length === 0"
                                @dragover.prevent @drop="handleDrop(modulo.id, 0)">
                                <p class="empty-message">Arraste tópicos para cá</p>
                              </div>
                              <div v-for="(lesson, lessonIndex) in modulo.lessons" :key="lesson.order" class="faq-grid">
                                <div class="drag-item" draggable="true"
                                  @dragstart="handleDragStart(modulo.id, lesson.id)" @dragover.prevent
                                  @drop="handleDrop(modulo.id, lessonIndex)">
                                  <div class="faq-header">
                                    <a class="collapsed faq-collapse" :data-bs-toggle="'collapse'"
                                      :href="'#collapse' + lesson.order">
                                      <i class="fas fa-align-justify"></i>
                                      {{ lesson.title }}
                                    </a>
                                    <div class="faq-right">
                                      <a href="javascript:void(0);">
                                        <i class="far fa-pen-to-square me-1"></i>
                                      </a>
                                      <a @click="removeLesson(modulo, lesson)" class="me-0">
                                        <i class="far fa-trash-can"></i>
                                      </a>
                                    </div>
                                  </div>
                                  <div :id="'collapse' + lesson.order" class="collapse" :data-bs-parent="'#accordion'">
                                    <div class="faq-body">
                                      <input type="text" class="form-control mb-12" style="padding-bottom: 12px;"
                                        placeholder="Título" v-model="lesson.title" />

                                      <div class="form-group">
                                        <label class="add-course-label">Tipo do Conteúdo</label>
                                        <vue-select :options="contentType" placeholder="Selecione"
                                          v-model="lesson.contentType" />
                                      </div>

                                      <div class="form-group"
                                        v-if="lesson.contentType === 'YOUTUBE' || lesson.contentType === 'PANDA'">
                                        <label class="add-course-label">Url do Conteúdo</label>
                                        <input type="text" class="form-control mb-12" style="padding-bottom: 12px;"
                                          placeholder="Título" v-model="lesson.contentUrl" />
                                      </div>
                                      <div class="form-group" v-if="lesson.contentType === 'PDF'">

                                        <div class="input-block">
                                          <label class="add-course-label">Selecione o Documento</label>
                                          <div class="relative-form">
                                            <span>{{ lesson.contentUrl }}</span>
                                            <label class="relative-file-upload">
                                              Upload <input id="fileInput" type="file" class="form-control"
                                                @change="handleLessonPDFChange($event, lesson)" />
                                            </label>
                                          </div>
                                        </div>

                                      </div>
                                      <!-- Quiz Pré-requisito (para todos os tipos de lesson) -->
                                      <div class="form-group" v-if="lesson.contentType && lesson.contentType !== 'QUIZ'">
                                        <label class="add-course-label">Quiz Pré-requisito</label>
                                        <vue-select
                                          :options="getQuizLessonsForPrerequisite(lesson)"
                                          placeholder="Selecione um quiz pré-requisito (opcional)"
                                          v-model="lesson.requiredQuizLessonId"
                                          :clearable="true"
                                        />
                                        <small class="form-text text-muted">Esta aula só ficará acessível após o aluno completar o quiz selecionado</small>
                                      </div>
                                      <!-- Quiz Configuration -->
                                      <div v-if="lesson.contentType === 'QUIZ'" class="quiz-config-section">
                                        <div class="form-group">
                                          <label class="add-course-label">Selecione o Quiz</label>
                                          <vue-select
                                            :options="quizzes"
                                            placeholder="Selecione um quiz"
                                            v-model="lesson.quizId"
                                            :required="lesson.contentType === 'QUIZ'"
                                          />
                                        </div>
                                        <div class="form-group">
                                          <label class="add-course-label">Tipo de Quiz</label>
                                          <vue-select
                                            :options="quizTypeOptions"
                                            placeholder="Selecione o tipo (opcional)"
                                            v-model="lesson.quizType"
                                            :clearable="true"
                                          />
                                        </div>
                                        <div class="form-group">
                                          <label class="add-course-label">Quiz Pré-requisito</label>
                                          <vue-select
                                            :options="getQuizLessonsForPrerequisite(lesson)"
                                            placeholder="Selecione um quiz pré-requisito (opcional)"
                                            v-model="lesson.requiredQuizLessonId"
                                            :clearable="true"
                                          />
                                          <small class="form-text text-muted">Este quiz só ficará acessível após completar o quiz selecionado</small>
                                        </div>
                                        <div class="form-group">
                                          <label class="custom_check">
                                            <input type="checkbox" name="requiresPreviousQuiz" v-model="lesson.requiresPreviousQuiz" />
                                            <span class="checkmark"></span> Requer Quiz Anterior?
                                          </label>
                                        </div>
                                        <div class="form-group">
                                          <label class="add-course-label">% Mínimo de Acertos (0-100)</label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            placeholder="Ex: 70"
                                            v-model.number="lesson.minimumScorePercent"
                                            min="0"
                                            max="100"
                                          />
                                        </div>
                                        <div class="form-group">
                                          <label class="add-course-label">Máximo de Tentativas</label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            placeholder="Ex: 1"
                                            v-model.number="lesson.maxAttempts"
                                            min="1"
                                          />
                                        </div>
                                      </div>
                                      <label class="custom_check">
                                        <input type="checkbox" name="select_specialist" v-model="lesson.isEnabled" />
                                        <span class="checkmark"></span> Aula Liberada?
                                      </label>
                                      <label class="custom_check">
                                        <input type="checkbox" name="select_specialist" v-model="lesson.publicAccess" />
                                        <span class="checkmark"></span> Acesso Público?
                                      </label>
                                      <!-- <div class="add-article-btns"  style="margin-top: 16px;" >

                                      <a href="javascript:void(0);" class="btn">Add Article</a>
                                      <a href="javascript:void(0);" class="btn me-0">Add Description</a>
                                    </div> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="widget-btn">
                        <a class="btn btn-black prev_btn" @click="previousStep"
                          :disabled="currentStep === 2">Anterior</a>
                        <a class="btn btn-info-light next_btn" @click="nextStep"
                          :disabled="currentStep === totalSteps">Próximo</a>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="field-card" v-if="currentStep === 4">
                    <div class="add-course-info">
                      <!-- <div class="add-course-inner-header">
                      <h4>Requirements</h4>
                    </div> -->
                      <div class="add-course-form">
                        <form action="#">
                          <!-- <div class="form-group form-group-tagsinput">
                          <vue3-tags-input :tags="tags" />
                        </div> -->
                          <div class="col-md-6">
                            <div class="input-block">
                              <label class="add-course-label">Situação do Curso</label>
                              <vue-select :options="['PENDENTE', 'PUBLICADO']" placeholder="Selecione"
                                v-model="courseEntity.status" />
                            </div>
                          </div>
                          <div class="row" style="margin-top: 16px;">
                            <div class="col-md-6">
                              <div class="form-group mb-0">
                                <label class="add-course-label">Preço Base</label>
                                <money3 v-model="courseEntity.basePrice" v-bind="configMoney" placeholder="R$0,00"
                                  class="form-control" @blur="calculatePrice()" />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-0">
                                <label class="add-course-label">ID do Produto na Green</label>
                                <input v-model="courseEntity.greenProductId" type="number"
                                  class="form-control"  />
                              </div>
                            </div>
                          </div>

                          <div class="row" style="margin-top: 16px;">
                            <div class="col-md-6">
                              <label class="add-course-label">Liberar o certificado em:</label>
                              <date-picker v-model="courseEntity.activeCertificateDate"
                                class="datetimepicker form-control" :editable="true" :clearable="false"
                                :input-format="dateFormat" />
                            </div>


                          </div>
                          <div class="row" style="margin-top: 16px;">
                            <div class="col-md-6">
                              <label class="custom_check">
                                <input type="checkbox" name="select_specialist"
                                  v-model="courseEntity.freeToSubscribers" />
                                <span class="checkmark"></span> Gratuito para Assinantes?
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="custom_check">
                                <input type="checkbox" name="select_specialist" v-model="courseEntity.isPublic" />
                                <span class="checkmark"></span> Acesso Público?
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="custom_check">
                                <input type="checkbox" name="select_specialist"
                                  v-model="courseEntity.enableCertificate" />
                                <span class="checkmark"></span> Habilitar Emissão de Certificado?
                              </label>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <label class="custom_check">
                                <input type="checkbox" name="select_specialist"
                                  v-model="courseEntity.enableEnrollment" />
                                <span class="checkmark"></span> Habilitar Matriculas (Abrir pra vendas)?
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="input-block">
                                <label class="add-course-label">Imagem do Certificado (Background)</label>
                                <div class="relative-form">
                                  <span>Nenhum arquivo selecionado</span>
                                  <label class="relative-file-upload">
                                    Upload <input id="fileInput" type="file" class="form-control"
                                      @change="handleFileCertificadoChange" />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-12">
                              <div class="input-block">
                                <div class="add-image-box">
                                  <a href="javascript:void(0);" v-if="!courseEntity.certificateBackgroundUrl">
                                    <i class="far fa-image" v-if="!courseEntity.certificateBackgroundUrl"></i>

                                  </a>
                                  <img :src="courseEntity.certificateBackgroundUrl"
                                    v-if="courseEntity.certificateBackgroundUrl" height="800">
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="form-group" style="margin-top: 12px;" v-for="discount in discounts" :key="discount.id">
                          <div class="row">
                            <div class="col-md-6">
                            <label class="add-course-label">Preço para {{ discount.name }}: Padrão ({{ discount.percentage *100 }}%)</label>
                            <money3 v-model="discount.price" v-bind="configMoney" placeholder="R$0,00" class="form-control"/>
                          </div>
                          <div class="col-md-6">
                            <label class="add-course-label">Preço para {{ discount.name }}: Aluno Caduceus ({{ discount.percentage_caduceus *100 }}%)</label>
                            <money3 v-model="discount.price" v-bind="configMoney" placeholder="R$0,00" class="form-control"/>
                          </div>

                          </div>
                        </div> -->
                        </form>
                      </div>
                      <div class="widget-btn">
                        <a class="btn btn-black prev_btn" @click="previousStep"
                          :disabled="currentStep === 3">Anterior</a>
                        <!-- <a class="btn btn-info-light next_btn" @click="nextStep"
                          :disabled="currentStep === totalSteps">Próximos</a> -->
                        <a @click="salvar()" class="btn btn-success-dark">Salvar</a>

                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="field-card" v-if="currentStep === 5">
                    <div class="add-course-info">
                      <div class="add-course-msg">
                        <i class="fas fa-circle-check"></i>
                        <h4>O Curso {{ courseEntity.title }} foi adicionado com sucesso!</h4>
                        <p>O Curso ainda encontra-se no status Pendente para que você possa revisá-lo. </p>
                        <p>O Curso só ficará disponível para o público em geral após a aprovação do administrador. </p>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <!-- /Course Wizard -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /New Course -->
  </div>

  <!-- <layouts1></layouts1> -->
</template>
<script setup>
import { onMounted, ref, computed } from "vue";
import Vue3TagsInput from "vue3-tags-input";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ApiService from '@/services/ApiService';
import axiosInstance, { tratarError } from "@/axiosConfig";
import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
import 'vue-lite-youtube-embed/style.css'
import { useToast } from "vue-toast-notification";
import { JWTHandler } from "@/jwtHandler";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import QuizService from "@/services/quiz.service";
// Componentes    <youtube video-id="dQw4w9WgXcQ"></youtube>
const route = useRoute();

const courseId = route.params.id;
const modoEdicao = courseId !== undefined;

// Verificar se usuário pode visualizar o curso (ADMIN ou INSTRUCTOR)
const canViewCourse = computed(() => {
  if (!courseEntity.value?.id) return false;
  const userData = JWTHandler.getUserData();
  if (!userData) return false;
  return userData.isRole('ADMIN') || userData.isRole('INSTRUCTOR');
});

// Configurações para a máscara de moeda
const configMoney = {
  prefix: 'R$ ',
  thousands: '.',
  decimal: ',',
  precision: 2
};

const editor = ClassicEditor;
// const editorData = ref("");
const editorConfig = {
  // Configuração adicional para ajustar altura
  // toolbar: [
  //   "undo",
  //   "redo",
  //   "heading",
  //   "|",
  //   "bold",
  //   "italic",
  //   "link",
  //   "bulletedList",
  //   "numberedList",
  //   "|",

  // ],
  height: '500px', // Isso nem sempre funciona, mas pode ser usado como fallback
};
const tags = ref(["jquery", "bootstrap"]);
const Category = ref([]);

const Inscructors = ref([]);
const Level = ["Básico", "Intermediário", "Avançado"];
const currentStep = ref(1);
const totalSteps = 5;
const content = ref("Description");
const discounts = ref([]);
onMounted(async () => {
  const editorElement = document.querySelector('.ck-editor__editable_inline');
  if (editorElement) {
    editorElement.style.minHeight = '500px';
    editorElement.style.maxHeight = '800px';
    editorElement.style.overflowY = 'auto';
  }

  try {
    const response = await ApiService.get('/categories');
    response.data.map(c => {
      Category.value.push({ id: c.id, text: c.description })
    })

    const response2 = await ApiService.get('/users/instructors');
    response2.data.map(c => {
      Inscructors.value.push({ id: c.id, text: c.fullName })
    })

    // courseEntity.value = { "title": "Eletrocardiografia da criança os 10 mandamentos", "description": "<h2><strong>Médico Pediatra</strong></h2><p>Mais de um milhão de ECGs são realizados diariamente em todo o mundo, destacando o papel crítico dessa ferramenta de diagnóstico na saúde.</p><p>A interpretação do eletrocardiograma em crianças, no entanto, é mais desafiadora devido à variação dos traçados nas diferentes faixas etárias e à multiplicidade de anomalias congênitas.&nbsp;</p><p>Esses fatores tornam os recursos automatizados menos precisos ou indisponíveis. Dessa forma, um número significativo desses ECGs não é interpretado devido à falta de habilidades especializadas e o potencial da eletrocardiografia permanece subutilizado nesse grupo crucial de pacientes.</p><p>Isso destaca a necessidade urgente de mais treinamento especializado e recursos para garantir que cada ECG possa contribuir para melhores resultados de saúde, especialmente nas crianças.</p><p>O traçado do ECG é como um código, o objetivo deste curso é fornecer aos alunos os elementos necessários para decifrar esse código e interpretar com sucesso os ECGs de crianças de diferentes faixas etárias.</p><p>&nbsp;</p><h2><strong>Para quem é o curso?</strong></h2><p>&nbsp;</p><ul><li>Pediatras: ganhe segurança na avaliação do ECG em consultório ou na emergência pediátrica diferenciando aqueles que que podem ser conduzidos na pediatria e os que que necessitam de avaliação pelo cardiologista pediátrico;</li><li>Neonatologistas: identifique a necessidade de avaliação cardiológica imediata e o caráter de urgência associando a análise do traçado eletrocardiográfico ao exame clínico;</li><li>Residentes e estudantes de medicina: preencha uma lacuna da graduação e residência aprendendo, desde cedo, a \"ler\" o eletrocardiograma da criança.</li></ul>", "categoryId": 1, "level": "Básico", "basePrice": 197, "instructorId": JWTHandler.getUserData().id, "coverImage": "https://s3.us-west-2.amazonaws.com/echoflix.com.br/3238ba22-f6a9-4681-807b-2368fff32c30.png", "videoUrl": "GpxUtOVP5b4", "modules": [{ "id": 1736911147469, "title": "Introdução à Eletrocardiografia", "order": 1, "lessons": [{ "id": 1736911147470, "order": 1, "title": "Aspectos históricos (parte 1)", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911151436, "order": 2, "title": "Aspectos históricos (parte 2)", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911152002, "order": 3, "title": "Eletrofisiologia (parte 1)", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911234721, "order": 4, "title": "Eletrofisiologia (parte 2)", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }] }, { "id": 1736911153667, "title": "Convenções Eletrocardiográficas", "order": 1, "lessons": [{ "id": 1736911153668, "order": 1, "title": "O papel do registro", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911260954, "order": 2, "title": "Posição dos eletrodos", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911274418, "order": 3, "title": "Derivações eletrocardiográficas", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911274835, "order": 4, "title": "Sistema hexa axial", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911296383, "order": 5, "title": "Componentes do eletrocardioma", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }] }, { "id": 1736911178102, "title": "Sobrecarga", "order": 1, "lessons": [{ "id": 1736911178103, "order": 1, "title": "Sobrecarga atrial", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911312254, "order": 2, "title": "Sobrecarga ventricular", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }] }, { "id": 1736911191814, "title": "Distúrbios do Ritmo Cardíaco", "order": 1, "lessons": [{ "id": 1736911191815, "order": 1, "title": "Ritmo cardíaco", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911333549, "order": 2, "title": "Frequência cardíaca", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911334024, "order": 3, "title": "Distúrbios da formação do impulso", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911334587, "order": 4, "title": "Distúrbios da condução do impulso", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }, { "id": 1736911334821, "order": 5, "title": "Distúrbios da formação e condução do impulso", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }] }, { "id": 1736911201207, "title": "Os 10 mandamentos do ECG pediátrico", "order": 1, "lessons": [{ "id": 1736911201208, "order": 1, "title": "Os 10 Mandamentos do ECG Pediátrico", "contentType": "YOUTUBE", "contentUrl": "https://www.youtube.com/watch?v=GpxUtOVP5b4" }] }] }

    const responseDiscounts = await ApiService.get('/discounts');
    discounts.value = responseDiscounts.data;

    discounts.value.map(d => d['price'] = 0.0);


    if (modoEdicao) {
      const responseCourseId = await ApiService.get(`/courses/${courseId}/edit`);

      courseEntity.value = responseCourseId.data;
      courseEntity.value['deletedModules'] = [];
      courseEntity.value['deletedLessons'] = [];

      // Load quizzes for the course
      await loadQuizzes(courseId);
    } else if (courseEntity.value.id) {
      // If course was just created, load quizzes
      await loadQuizzes(courseEntity.value.id);
    }
  } catch (error) {
    tratarError(error)
  }


  // Category.value = response.data;
});

const calculatePrice = () => {
  console.log("calculando...")
  // discounts.value.map(d => d.price = courseEntity.value.basePrice - (d.percentage * courseEntity.value.basePrice))
  // discounts.value.map(d => d.price = courseEntity.value.basePrice - (d.percentage * courseEntity.value.basePrice))
  courseEntity.value.coursePrices = discounts.value.map(d => {
    return { discountId: d.id, price: +courseEntity.value.basePrice - (+d.percentage * +courseEntity.value.basePrice) };
  });
  console.log(courseEntity.value.coursePrices)
}
// Métodos
const nextStep = () => {
  if (currentStep.value === 4) {
    ApiService.post('/courses', courseEntity.value)
    // currentStep.value++;
  }
  if (currentStep.value < totalSteps) {
    currentStep.value++;
  }
};

const previousStep = () => {
  if (currentStep.value > 1) {
    currentStep.value--;
  }
};
const selectedFile = ref(null)

const handleFileChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    // Valida o arquivo antes de enviar
    const isValid = await validateImageDimensions(file, 368, 207); // Exemplo: 500x300 pixels
    if (!isValid) {
      useToast().error('A imagem deve ter dimensões de 368x207 pixels.');
      return;
    }

    selectedFile.value = file;
    await uploadFile(file);
  }
  // const file = event.target.files[0]
  // if (file) {
  //   selectedFile.value = file
  //   await uploadFile(file)
  // }
}




const handleLessonPDFChange = async (event, lesson) => {
  const file = event.target.files[0];
  if (file) {
    // selectedFileCertificado.value = file;
    await uploadLessonPDF(file, lesson);
  }
}
// Método para enviar o arquivo para o backend
const uploadLessonPDF = async (file, lesson) => {
  try {
    const formData = new FormData()
    formData.append('file', file) // Adiciona o arquivo ao FormData

    // Faz a requisição POST para o backend
    const response = await ApiService.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Header necessário para upload de arquivos
      },
    })
    lesson.contentUrl = response.data.url
    // courseEntity.value.certificateBackgroundUrl = response.data.url
    console.log('Upload realizado com sucesso:', response.data)
  } catch (error) {
    console.error('Erro ao fazer upload:', error)
  }
}


const selectedFileCertificado = ref(null)

const handleFileCertificadoChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    selectedFileCertificado.value = file;
    await uploadFileCertificado(file);
  }
}
// Método para validar dimensões da imagem
const validateImageDimensions = (file, requiredWidth, requiredHeight) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      if (img.width === requiredWidth && img.height === requiredHeight) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    img.onerror = () => resolve(false);

    // Carrega a imagem a partir do arquivo
    img.src = URL.createObjectURL(file);
  });
};

// Método para enviar o arquivo para o backend
const uploadFile = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file) // Adiciona o arquivo ao FormData

    // Faz a requisição POST para o backend
    const response = await ApiService.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Header necessário para upload de arquivos
      },
    })
    courseEntity.value.coverImage = response.data.url
    console.log('Upload realizado com sucesso:', response.data)
  } catch (error) {
    console.error('Erro ao fazer upload:', error)
  }
}


// Método para enviar o arquivo para o backend
const uploadFileCertificado = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file) // Adiciona o arquivo ao FormData

    // Faz a requisição POST para o backend
    const response = await ApiService.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Header necessário para upload de arquivos
      },
    })
    courseEntity.value.certificateBackgroundUrl = response.data.url
    console.log('Upload realizado com sucesso:', response.data)
  } catch (error) {
    console.error('Erro ao fazer upload:', error)
  }
}
const dateFormat = ref('dd/MM/yyyy');
const courseEntity = ref({
  title: "", // Título do curso
  status: 'PENDENTE',
  description: "", // Descrição do curso
  categoryId: "", // Categoria do curso (e.g., "Category 01")
  level: "", // Nível do curso (e.g., "Level 01")
  basePrice: 0.0, // Preço base do curso
  greenProductId: undefined,
  instructorId: JWTHandler.getUserData().id, // ID do professor responsável
  coverImage: "", // URL da imagem de capa do curso
  videoUrl: "OgZxUaD6IJw", // URL do vídeo do curso
  coursePrices: [],
  activeCertificateDate: new Date(),
  freeToSubscribers: false,
  isPublic: false,
  enableCertificate: false,
  enableEnrollment: true,
  deletedModules: [],
  deletedLessons: [],
  certificateBackgroundUrl: "",
  //tags: [], // Tags relacionadas ao curso (e.g., ["jquery", "bootstrap"])
  modules: [
    {
      id: Date.now(),
      title: "", // Título da seção
      order: 1,
      isEnabled: false,
      lessons: [
        {
          id: Date.now() + 1,
          order: 1,
          isEnabled: false,
          publicAccess: false,
          title: "", // Título da aula
          contentType: undefined, // Conteúdo da aula (e.g., texto ou HTML)
          contentUrl: undefined, //Conteúdo da aula (e.g., texto ou HTML)
          quizId: undefined,
          requiresPreviousQuiz: false,
          minimumScorePercent: undefined,
          maxAttempts: 1,
          quizType: undefined,
          requiredQuizLessonId: undefined,
        },
      ],
    },
  ],
});
const contentType = ref([
  { id: 'YOUTUBE', text: 'YouTube' }, 
  { id: 'PANDA', text: 'Panda Video' }, 
  { id: 'PDF', text: 'PDF' },
  { id: 'QUIZ', text: 'Quiz' }
]);
const quizzes = ref([]);

// Quiz type options
const quizTypeOptions = ref([
  { id: 'PRE_TEST', text: 'Pré-teste' },
  { id: 'POST_TEST', text: 'Pós-teste' }
]);

// Function to get quiz lessons for prerequisite dropdown
const getQuizLessonsForPrerequisite = (currentLesson) => {
  const quizLessons = [];

  for (const module of courseEntity.value.modules) {
    for (const lesson of module.lessons) {
      // Only include quiz lessons and exclude the current lesson
      if (lesson.contentType === 'QUIZ' && lesson.id !== currentLesson.id) {
        quizLessons.push({
          id: lesson.id,
          text: `${lesson.title} (${module.title})`
        });
      }
    }
  }

  return quizLessons;
};

const addModulo = () => {
  courseEntity.value.modules.push({
    id: undefined,
    title: "", // Título da seção
    order: 1,
    isEnabled: false,
    lessons: [
      {
        id: undefined,
        order: 1,
        isEnabled: false,
        title: "", // Título da aula
        publicAccess: false,
        contentType: undefined, // Conteúdo da aula (e.g., texto ou HTML)
        contentUrl: undefined, // Conteúdo da aula (e.g., texto ou HTML)
        quizId: undefined,
        requiresPreviousQuiz: false,
        minimumScorePercent: undefined,
        maxAttempts: 1,
        quizType: undefined,
        requiredQuizLessonId: undefined,
      },
    ],
  })
}
const validateQuizLessons = () => {
  for (const module of courseEntity.value.modules) {
    for (const lesson of module.lessons) {
      if (lesson.contentType === 'QUIZ') {
        if (!lesson.quizId) {
          Swal.fire("", `A aula "${lesson.title}" requer a seleção de um quiz.`, "error");
          return false;
        }
        if (lesson.minimumScorePercent !== undefined && (lesson.minimumScorePercent < 0 || lesson.minimumScorePercent > 100)) {
          Swal.fire("", `A aula "${lesson.title}" deve ter % mínimo entre 0 e 100.`, "error");
          return false;
        }
        if (lesson.maxAttempts !== undefined && lesson.maxAttempts < 1) {
          Swal.fire("", `A aula "${lesson.title}" deve ter pelo menos 1 tentativa permitida.`, "error");
          return false;
        }
      }
    }
  }
  return true;
};


const cleanLessonFields = (lesson) => {
  // Remove undefined/null/empty values for optional quiz fields
  const cleaned = { ...lesson };
  if (cleaned.quizId === undefined || cleaned.quizId === null || cleaned.quizId === '') {
    delete cleaned.quizId;
  }
  if (cleaned.minimumScorePercent === undefined || cleaned.minimumScorePercent === null || cleaned.minimumScorePercent === '') {
    delete cleaned.minimumScorePercent;
  }
  if (cleaned.maxAttempts === undefined || cleaned.maxAttempts === null || cleaned.maxAttempts === '') {
    delete cleaned.maxAttempts;
  }
  if (cleaned.requiresPreviousQuiz === undefined || cleaned.requiresPreviousQuiz === null) {
    delete cleaned.requiresPreviousQuiz;
  }
  if (cleaned.requiredQuizLessonId === undefined || cleaned.requiredQuizLessonId === null || cleaned.requiredQuizLessonId === '') {
    delete cleaned.requiredQuizLessonId;
  }
  if (cleaned.quizType === undefined || cleaned.quizType === null || cleaned.quizType === '') {
    delete cleaned.quizType;
  }
  return cleaned;
};

const salvar = async () => {
  try {
    calculatePrice();
    courseEntity.value.instructorId = parseInt(courseEntity.value.instructorId)
    courseEntity.value.categoryId = parseInt(courseEntity.value.categoryId)
    courseEntity.value.basePrice = parseFloat(courseEntity.value.basePrice)
    if (!courseEntity.value.isPublic && courseEntity.value.basePrice === 0) {
      Swal.fire("", "O Preço é obritatório para os cursos que não tem acesso público.", "error")
      return;
    }

    // Validate quiz lessons
    if (!validateQuizLessons()) {
      return;
    }

    // Clean lesson fields before sending
    const courseDataToSend = JSON.parse(JSON.stringify(courseEntity.value));
    courseDataToSend.modules = courseDataToSend.modules.map(module => ({
      ...module,
      lessons: module.lessons.map(cleanLessonFields)
    }));

    // Remove activeCertificateDate if null, undefined, or empty
    if (courseDataToSend.activeCertificateDate === null || 
        courseDataToSend.activeCertificateDate === undefined || 
        courseDataToSend.activeCertificateDate === '') {
      delete courseDataToSend.activeCertificateDate;
    }

    if (courseEntity.value.id) {
      delete courseDataToSend.createdAt
      delete courseDataToSend.updatedAt
      delete courseDataToSend.instructor
      delete courseDataToSend.category

      const response = await ApiService.put('/courses/' + courseEntity.value.id, courseDataToSend)
      courseEntity.value = response.data;
      courseEntity.value['deletedModules'] = [];
      courseEntity.value['deletedLessons'] = [];

      // Reload quizzes after save
      await loadQuizzes(courseEntity.value.id);

      Swal.fire("", "Curso atualizado com sucesso.", "success");
    } else {
      delete courseDataToSend.deletedLessons
      delete courseDataToSend.deletedModules
      const response = await ApiService.post('/courses', courseDataToSend);
      courseEntity.value = response.data;
      
      // Load quizzes after course creation
      await loadQuizzes(courseEntity.value.id);
      
      Swal.fire("", "Curso criado com sucesso.", "success");

      // courseEntity.value = response.data
    }



    // useToast().success('O curso foi salvo com sucesso!')

  } catch (error) {
    console.log(error)
    // useToast().error('Erro interno ao tentar salvar o curso')
  }

}
const loadQuizzes = async (courseId) => {
  try {
    const response = await QuizService.listByCourse(courseId);
    quizzes.value = response.data.map(quiz => ({
      id: quiz.id,
      text: quiz.title
    }));
  } catch (error) {
    console.error('Error loading quizzes:', error);
  }
};

const addLesson = (modulo) => {
  modulo.lessons.push({
    id: undefined,
    order: modulo.lessons.length + 1,
    title: "",
    isEnabled: false,
    publicAccess: false,
    contentType: undefined,
    contentUrl: undefined,
    quizId: undefined,
    requiresPreviousQuiz: false,
    minimumScorePercent: undefined,
    maxAttempts: 1,
    quizType: undefined,
    requiredQuizLessonId: undefined,
  });
}

const removeLesson = (module, lesson) => {
  Swal.fire({
    icon: "warning",
    // title: ``,
    text: `Você confirma a exclusão da Aula ${lesson.title}?`,
    showDenyButton: true,
    // showCancelButton: true,
    confirmButtonText: "Remover",
    denyButtonText: `Cancelar`
  }).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      console.log('removing')
      module.lessons = module.lessons.filter(l => l.id !== lesson.id);

      Swal.fire("Aula removida!", "Para que as alterações sejam efetivadas, você deverá salvar o curso.", "success");
      courseEntity.value.deletedLessons.push(+lesson.id)

    } else if (result.isDenied) {
      // Swal.fire("Changes are not saved", "", "info");
    }
  });
}
const removeModulo = (mod) => {
  Swal.fire({
    icon: "warning",
    // title: ``,
    text: `Você confirma a exlcusão do módulo ${mod.title}?`,
    showDenyButton: true,
    // showCancelButton: true,
    confirmButtonText: "Remover",
    denyButtonText: `Cancelar`
  }).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {

      courseEntity.value.modules = courseEntity.value.modules.filter(m => m.id !== mod.id);
      courseEntity.value.deletedModules.push(+mod.id);
      Swal.fire("Módulo removido!", "Para que as alterações sejam efetivadas, você deverá salvar o curso.", "success");
    } else if (result.isDenied) {
      // Swal.fire("Changes are not saved", "", "info");
    }
  });
}

// Variáveis reativas para armazenar informações de drag-and-drop
const currentDragSectionId = ref(null);
const currentDragLessonId = ref(null);

const handleDragStart = (sectionId, lessonId) => {
  currentDragSectionId.value = sectionId;
  currentDragLessonId.value = lessonId;
};
const handleDrop = (targetSectionId, targetIndex) => {
  if (currentDragSectionId.value === null || currentDragLessonId.value === null) {
    console.error("Erro: Informação de drag inválida.");
    return;
  }

  // Identifica a seção de origem e destino
  const sourceSection = courseEntity.value.modules.find(
    (sec) => sec.id === currentDragSectionId.value
  );

  const targetSection = courseEntity.value.modules.find(
    (sec) => sec.id === targetSectionId
  );

  if (!sourceSection || !targetSection) {
    console.error("Erro: Seção de origem ou destino não encontrada.");
    return;
  }

  const lessonIndex = sourceSection.lessons.findIndex(
    (lesson) => lesson.id === currentDragLessonId.value
  );

  if (lessonIndex === -1) {
    console.error("Erro: Tópico de origem não encontrado.");
    return;
  }

  // Remove o tópico da seção de origem
  const [movedLesson] = sourceSection.lessons.splice(lessonIndex, 1);

  // Adiciona o tópico na nova posição da seção de destino
  targetSection.lessons.splice(targetIndex, 0, movedLesson);

  // Atualiza a ordem dos tópicos em ambas as seções
  sourceSection.lessons.forEach((lesson, index) => {
    lesson.order = index + 1;
  });
  targetSection.lessons.forEach((lesson, index) => {
    lesson.order = index + 1;
  });

  // Limpa o estado do drag
  currentDragSectionId.value = null;
  currentDragLessonId.value = null;
};


// const handleDragEnter = (sectionId, lessonIndex) => {
//   // Atualiza o índice do tópico no qual o item será solto
//   currentDragSectionId.value = sectionId;
//   currentDragLessonId.value = lessonIndex;
// };
</script>

<style scoped>
.drag-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}

.drag-item {
  padding: 30px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  cursor: grab;
  transition: all 0.2s;
}

.drag-item:active {
  cursor: grabbing;
  background-color: #e0e0e0;
}

.drag-item:hover {
  background-color: #f0f0f0;
}

.empty-section-dropzone {
  border: 2px dashed #ccc;
  padding: 10px;
  text-align: center;
  background-color: #f9f9f9;
  min-height: 50px;
  transition: background-color 0.2s ease;
}

.empty-section-dropzone:hover {
  background-color: #e6e6e6;
}

.empty-message {
  color: #aaa;
  font-style: italic;
}

.ck-editor {
  height: auto;
}

.ck-editor__editable_inline {
  min-height: 500px !important;
  max-height: 800px !important;
  overflow-y: auto;
}
</style>

<style scoped>
::v-deep(.ck-editor__editable_inline) {
  min-height: 500px !important;
  max-height: 800px !important;
  overflow-y: auto;
}

.currency-input {
  /* Adicione estilos personalizados conforme necessário */
  width: 200px;
  padding: 5px;
  font-size: 16px;
}

.swal2-icon {
  display: flex !important;
  justify-content: center;
  align-items: center;
  width: 5em !important;
  height: 5em !important;
  font-size: 3em !important;
}
</style>
